import React from "react";
import PropTypes from "prop-types";
import { t } from '@insight/toolkit-utils';
 
const CalloutBox = ({ callForPriceLabel, callForPriceLabelNumber, isCallForPrice, loginLink, accountLink, contactNumberValue }) => {
    return (
        <div>
            {isCallForPrice && callForPriceLabel && (
                <div className="c-callooutbox__label"><p className="c-callooutbox__label-text">{callForPriceLabel}</p></div>
            )}
            <div className="c-callooutbox__container">
                {isCallForPrice ? (
                    <div className="call-for-price-text-container"><a href={`tel:+${contactNumberValue}`} className="c-callooutbox__button-text">{callForPriceLabelNumber}</a></div>
                ) : (
                    <div>
                        <div>
                            <a className="c-button--inline-link" href={loginLink}>{t('Login')}</a> or <a className="c-button--inline-link" href={accountLink}>{t('request an account')}</a></div>
                            <div className="account-price-text">
                            {t('to view price')}
                        </div></div>
                )}
            </div></div>
    );
};
 
CalloutBox.propTypes = {
    callForPriceLabel: PropTypes.string,
    callForPriceLabelNumber: PropTypes.string,
    isCallForPrice: PropTypes.bool,
    loginLink: PropTypes.string,
    accountLink: PropTypes.string,
    contactNumberValue: PropTypes.string,
};
 
export default CalloutBox;